module.exports = __webpack_public_path__ + "static/media/smart-work-baner-second-mobile.6d75c2b7.jpg";